<script setup lang="ts">
import BaseVideoThumnail from '@/components/base/BaseVideoThumbnail.vue'
import { useIsMobile } from '@/composables/useMediaQuery'
import type { Lecture } from '@/types/lecture.types'
import { useRouter } from 'vue-router'

const router = useRouter()

const props = defineProps<{
  lecture: Lecture
}>()

const isMobile = useIsMobile()

const handleVideoClick = () => {
  router.push(`/video/${props.lecture.idx}`)
}
</script>

<template>
  <BaseVideoThumnail
    :lecture="props.lecture"
    :showLevel="true"
    :maxWidth="isMobile ? 600 : 413"
    @video-click="handleVideoClick"
  />
</template>
